import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RequestPageComponent } from './request-page/request-page.component';
import { WebRequestRoutes } from './web-request.routing';
import { FooterComponent, HeaderComponent, LoaderModule } from 'src/app/components';
import { MaterialModule } from 'src/app/material/material.module';
import { MultipleLocationModule } from 'src/app/components/one-way/multiple-location/multiple-location.module';
import { RequestComponent } from "./request/request.component";
import { FormFieldsModule } from "../../components/form-fields/form-fields.module";
import { FormsModule } from "@angular/forms";
import { OneWayDetailsComponent } from './one-way-details/one-way-details.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
// import { NgParticlesModule } from "ng-particles";
import { BuyRequestDetailsComponent } from './buy-request-details/buy-request-details.component';
import { LeaseRequestDetailsComponent } from './lease-request-details/lease-request-details.component';
import { LeadSubmitComponent } from './lead-submit/lead-submit.component';
import { QuoteAcceptanceComponent } from './quote-acceptance/quote-acceptance.component';
import { BlankLeadComponent } from './blank-lead/blank-lead.component';
import { PipesModule } from 'src/app/pipes/pipes.module';

@NgModule({
  declarations: [
    RequestPageComponent,
    RequestComponent,
    FooterComponent,
    HeaderComponent,
    OneWayDetailsComponent,
    BuyRequestDetailsComponent,
    LeaseRequestDetailsComponent,
    LeadSubmitComponent,
    QuoteAcceptanceComponent,
    BlankLeadComponent,
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    RouterModule.forChild(WebRequestRoutes),
    MaterialModule,
    MultipleLocationModule,
    FormFieldsModule,
    MultipleLocationModule,
    ClipboardModule,
    FormsModule,
    // NgParticlesModule,
    LoaderModule,
    PipesModule,
  ]
})
export class WebRequestModule { }
